import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { CARRIER_PREFERENCE_TYPE_LABELS } from "../../constants/carrierPreferences"
import { PropertyRow } from "../PropertyRow"

import { CarrierChip } from "./CarrierChip"
import { getFreightTermLabel } from "./utils"

import { CarrierType, type LocationCarrierPreference } from "@/graphql/codegen/graphql"

interface CarrierPreferenceSectionProps {
  preference: LocationCarrierPreference
}

export const CarrierPreferenceSection: FC<CarrierPreferenceSectionProps> = ({ preference }) => {
  const typeLabel = CARRIER_PREFERENCE_TYPE_LABELS[preference.carrierType]

  return (
    <Box className='flex flex-col gap-3 py-4' data-test='carrier-preference-section'>
      <Typography variant='h6' className='text-base font-medium text-gray-900'>
        {typeLabel}
      </Typography>

      <Box className='flex flex-col'>
        <PropertyRow label='Carriers' value={<CarrierChip name={preference.carrier?.name} />} />
        <PropertyRow label='Acct #' value={preference.accountNumber} />
        {preference.carrierType === CarrierType.Sample ? (
          <PropertyRow
            label='Customer Pays for Sample Shipping'
            value={preference.customerPaysForSampleShipping ? "Yes" : "No"}
          />
        ) : (
          <PropertyRow label='Freight Terms' value={getFreightTermLabel(preference.freightTerms)} />
        )}
        <PropertyRow label='BOL Note' value={preference.note} />
        <PropertyRow label='Internal Comment' value={preference.comment} />
      </Box>
    </Box>
  )
}
